<template>
  <v-autocomplete
    dense
    outlined
    :items="items_"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :search-input.sync="search"
    :value.sync="value"
    class="dhivehi custom-select"
    :attach="true"
    no-data-text="އެއްވެސް އެއްޗެއް ނެތް.."
    @change="() => (search = null)"
  >
    <template #no-data>
      <div class="grey--text text-right px-2">އެއްވެސް އެއްޗެއް ނެތް.</div>
    </template>
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: null,
      validator: v => true,
      required: false,
    },
    searchUrl: {
      type: Function,
      default: null,
    },
    value: {
      default: null,
    },
    // initUrl: {
    //     type: [String, Function],
    //     default: null,
    // }
  },
  watch: {
    search: debounce(function (val) {
      if (!this.searchUrl || !this.val?.length || this.loading) return
      this.$axios
        .get(this.searchUrl(val))
        .then(res => {
          this.items_ = res.data
        })
        .finally(_ => (this.loading = false))
    }, 500),
    items(val) {
      if (val && val.length) this.items_ = val
    },
    url(val) {
      if (val) this.getItems()
    },
  },
  data: () => ({
    items_: [],
    loading: false,
    search: null,
  }),
  methods: {
    getItems() {
      this.loading = true
      this.$axios
        .get(this.url)
        .then(res => {
          this.items_ = res.data
        })
        .finally(_ => (this.loading = false))
    },
  },
  mounted() {
    if (this.url) this.getItems()
    else this.items_ = this.items
  },
}
</script>


<style scoped>
*::v-deep .v-list-item {
  text-align: right;
}
*::v-deep .v-select__selection {
  line-height: 1.5rem;
}
*::v-deep .v-list-item__content {
  font-family: Faruma;
  padding: 0 !important;
}
*::v-deep .v-list-item__action {
  margin: 0 0 0 10px !important;
}
*::v-deep .v-list-item__title {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
</style>